// src/elements/Table/Table.Td.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var Td = _ref => {
  let {
    children,
    className
  } = _ref;
  return /* @__PURE__ */jsx("td", {
    className: clsx("pd:table__td", className),
    children
  });
};
var Table_Td_default = Td;
export { Table_Td_default };